<script setup>
import Spinner from '../Spinner.vue';

/**
 * Se trata de mostrar un checkbox fake, no hay inputs solo los iconos que
 * representan si está marcado o no.
 */

const modelValue = defineModel({
  type: Boolean,
  required: true,
});
const loading = defineModel('loading', { type: Boolean, default: false });

const props = defineProps({
  spinnerOnClick: {
    type: Boolean,
    default: false,
  },
});

let eventoRelanzado = false;

/**
 * Como estamos cazando el evento click en Vue, el evento está modificado,
 * No es el original por lo que debemos lanzar un click nativo para que
 * el link superior sepa que ha sido pulsado y coja bien los datos
 * Ejemplo en tabla de desdobles
 */
function relanzarClickNativo(e) {
  e.preventDefault();
  e.stopPropagation();

  eventoRelanzado = true;

  // Relanza el evento click nativo
  const event = new MouseEvent('click', e);
  // Emite el evento desde el elemento raíz
  // Busca el elemento raíz del componente
  const root = e.currentTarget || e.target;
  root.dispatchEvent(event);
}

function handleClick(e) {
  if (eventoRelanzado) {
    // El evento está relanzado por lo que ya lo hemos procesado
    eventoRelanzado = false;
    return;
  }

  if (props.spinnerOnClick) {
    loading.value = true;
  }
  relanzarClickNativo(e);
}
</script>

<template>
  <span class="cifra-checkbox" @click="handleClick">
    <Spinner v-if="loading" />
    <i
      v-else
      :class="[
        'fa',
        modelValue ? 'fas fa-check-square' : 'far fa-square',
        modelValue ? 'text-cifra' : 'text-color-checkbox'
      ]"
    ></i>
  </span>
</template>
